<template>
  <div>
    <app-header></app-header>
    <div class="container-fluid admin-dashboard">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <app-admin-sidebar></app-admin-sidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4">
            <div :style="{ margin:'80px' }">
                <div class="alert alert-success alert-dismissible fade show" role="alert" v-if="successMessage">
                    {{ successMessage }}
                    <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>-->
                </div>
                <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="errorMessage">
                    {{ errorMessage }}
                    <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>-->
                </div>
                <ul class="m-b-0 ul-text-format t-center">
                    <li>Download template by clicking <b>Download SaasFees Data</b>.</li>
                    <li>Fill details in the downloaded file.</li>
                    <li>Upload your updated file by clicking <b>Choose File button.</b></li>
                    <li>Click on <b>Upload button</b> and wait for some time.</li>
                </ul>
                <div>
                    <input type="file" @change="handleFileUpload( $event )"/>
                    &nbsp;<button type="button" class="btn btn-primary" :disabled="isDisabled" @click="uploadSassFeesData()">Upload  
                        <span v-if="isDisabled"><font-awesome-icon icon="spinner" class="fa fa-spinner fa-spin" /></span></button>
                </div>
                <a class="text-danger" @click="downloadSaasFeesFile()">Download SaasFees Data <span v-if="isDisabled"><font-awesome-icon icon="spinner" class="fa fa-spinner fa-spin" /></span></a>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import divvyAdminSidebar from "@/views/divvyadmin/divvyAdminSidebar.vue";
import DashboardService from "../../../services/DashboardService"

export default {
  name: "divvyAdminDashboard",
  components: {
    appHeader: Header,
    appAdminSidebar: divvyAdminSidebar,
  },
  data() {
    return {
        isDisabled: false,
        sassFeesFile: "",
        successMessage: "",
        errorMessage: "",
    }
  },
  methods: {
      downloadSaasFeesFile() {
        this.isDisabled =true;
        DashboardService.downloadSaasFeesFile()
          .then((response) => {
            this.isDisabled =false;
            window.location.href = response.data.data;
          })
          .catch((e) => {
            this.isDisabled =false;
            this.$toast.error(e.response.data.respones_msg);
          });
      },
      handleFileUpload(event){
        this.sassFeesFile = event.target.files[0];
      },
      uploadSassFeesData() {
        if (this.sassFeesFile.type != "text/csv") {
            this.errorMessage = "Please select csv file for import";
            this.successMessage = "";
            this.sassFeesFile = "";
            return false;
        }
        this.isDisabled =true;
        let formData = new FormData();
        formData.append("csv", this.sassFeesFile);
        DashboardService.uploadSassFeesData(formData)
            .then((response) => {
                this.isDisabled =false;
                this.sassFeesFile = "";
                this.successMessage = response.data.responseMessage;
                this.errorMessage = "";
            })
            .catch((e) => {
                this.isDisabled =false;
                this.errorMessage = e.response.data.responseMessage;
                this.successMessage = "";
            });
      }
  },
  beforeMount() {
  },
};
</script>

<style lang="scss" scoped>
.admin-dashboard {
  // margin: 70px 0 0 0;
  min-height: 100%;
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
}

html,
body {
  height: 100%;
}

input[type=file] {
  width: auto;
  max-width: 100%;
  color: #444;
  padding: 5px;
  background: #fff;
  border-radius: 10px;
  border: 1px solid #555;
}
input[type=file]::file-selector-button {
  margin-right: 20px;
  border: none;
  background: #084cdf;
  padding: 10px 20px;
  border-radius: 10px;
  color: #fff;
  cursor: pointer;
  transition: background .2s ease-in-out;
}
input[type=file]::file-selector-button:hover {
  background: #0d45a5;
}
.alert {
    position: relative;
    padding: 0.75rem 1.25rem;
    margin-bottom: 1rem;
    border: 1px solid transparent;
    border-radius: 0.25rem;
}
.alert-success {
    color: #155724;
    background-color: #d4edda;
    border-color: #c3e6cb;
}
.alert-danger {
    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c6cb;
}
</style>
